import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface PublicLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout público para páginas que no requieren autenticación
 * (como política de privacidad, política de cookies, etc.)
 */

const PublicLayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  width: '100%',
  backgroundColor: theme.palette.background.default,
}));

const PublicMain = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  marginTop: 0,
  marginBottom: 0,
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    paddingInline: theme.spacing(3),
    paddingBlock: theme.spacing(4),
  },
  [theme.breakpoints.up('md')]: {
    paddingInline: theme.spacing(4),
    paddingBlock: theme.spacing(5),
  },
  [theme.breakpoints.up('lg')]: {
    paddingInline: theme.spacing(6),
  },
}));

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <PublicLayoutContainer>
      <PublicMain component="main" role="main">
        {children}
      </PublicMain>
    </PublicLayoutContainer>
  );
};

